/*
File handles all api calls for leads
*/

import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Leads = Class.create({
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
	},
	getLeads: function(filter, context) {
		// Call server for our data
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "leads";
		if (filter != null) {
			url = url + "?filter=" + filter;
		}
		// #  Send to server object for processing
		var data = this.server.getData(url,null,false);
		// #  Listen to our data
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			context.setState({ data: response.data });
		})
		.fail(function(e){
			console.log(e);
		});
	},
	getLeadsAsync: function(filter, callback) {
		// Call server for our data
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "leads";
		if (filter != null) {
			url = url + "?filter=" + filter;
		}
		// #  Send to server object for processing
		var data = this.server.getData(url,null,true);
		// #  Listen to our data
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			callback(response)
		})
		.fail(function(e){
			console.log(e);
		});
	},
	sendTemplate: function(container,templateID,data) {
		// #  Call our templating object to render
		var template = this.templating.setupTemplateHandlebarsWithData(container,templateID,data);
		// #  Lets file our action listeners now we have all our data pushed

		// #  Setup our action listeners now 
		this.initActionListeners();
		// #  Start datatable
		this.startDataTables();
	},
	sendTemplateWithoutActionListener: function(container,templateID,data) {
		// #  Call our templating object to render
		var template = this.templating.setupTemplateHandlebarsWithData(container,templateID,data);
	},
	sendTemplateWithAnimations: function(container,templateID,data,toMoveID,toBringIn,typeofanimation) {
		// #  Call our templating object to render
		var template = this.templating.setupTemplateHandlebarsWithDataWithAnimations(container,templateID,data,toMoveID,toBringIn,typeofanimation);
		// #  Lets file our action listeners now we have all our data pushed

		// #  Setup our action listeners now 
		//this.initActionListeners();
	},
	/**
	*
	* Creates a new tenant profile
	*
	*/
	addNewTenant: function(e) {
		this.tenantObject.addNewTenant();
	},
	/**
	*
	* Edits a tenant
	*
	*/
	editTenant: function(e) {
		var tenantID = jQuery(event.currentTarget).find('.tenantID').val();

		this.tenantObject.editTenant(tenantID);
	},
	/**
	*
	* Removes a secondary window
	*
	*/
	removeSecondaryView: function(e){
		this.domAnimationsObject.animateDOMid(this.addTenantSectionID,this.mainWindowContainerID,"drop");
	},
	getCommunityBoard: function(callback) {
		var self = this;
		var url = "tenants/communityboard";
		var data = this.server.getData(url,null,false);
		data
		.done(function(response){
			if(callback) {
				callback(response);
			}
		})
		.fail(function(e){
			console.log(e);
		});
	},
	updateCommunityBoard: function(message) {
		var self = this;
		var url = "tenants/communityboard";
		var params = message
		var data = this.server.getData(url, params, false, 'PUT');
		data
		.done(function(response){
			modal.showInfo("Community Board was Updated!", "success", "top", "center");
		})
		.fail(function(e){
			console.log(e);
		});
	},
	sendAlerts: function(content, callback) {
		var self = this;
		var url = "tenants/alert/all";
		var params = content
		modal.showDangerModalWithOK("Are you sure?","You are about to send out a mass alert to all tenants.","Yes, Alert All");
		jQuery(".move-on").on('click',function() {
			var data = self.server.getData(url, params, false, 'PUT');
			data
			.done(function(response){
				modal.showInfo("All Tenants have been Alerted!", "success", "top", "center");
				if(callback) {
					callback();
				}
			})
			.fail(function(e){
				console.log(e);
			});
		});
	},
	sendEmail: function(data, callback) {
		var self = this;
		var url = "tenants/email";
		var params = data;
		var data = this.server.getData(url,params,false, "POST");
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
});

export let leads = new Leads();


// WEBPACK FOOTER //
// app/core/controllers/Leads.js